import React from 'react';
import Button from '../ui/Button';

const ConversationButton = ({ hasNote, onClick, className = '', fullWidth = true }) => (
  <Button
    type="button"
    variant="outline"
    size="sm"
    fullWidth={fullWidth}
    iconName="MessagesSquare"
    onClick={onClick}
    className={className}
  >
    {hasNote ? 'Continue conversation' : 'Start conversation'}
  </Button>
);

export default ConversationButton;

